"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddSopLibraryModal = AddSopLibraryModal;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("@iconify/react");
var react_3 = require("react");
var area_library_1 = require("../../../features/apis/area-library");
var sop_library_1 = require("../../../features/apis/sop-library");
var button_component_1 = require("../../ui/button-component");
var labeled_field_1 = require("../../ui/labeled-field");
var text_component_1 = require("../../ui/text-component");
function AddSopLibraryModal(props) {
    var _this = this;
    var _a;
    var isOpen = props.isOpen, clientId = props.clientId, onClose = props.onClose, onCreated = props.onCreated;
    var _b = (0, react_3.useState)(""), name = _b[0], setName = _b[1];
    var _c = (0, react_3.useState)([]), selectedAreaLibraryIds = _c[0], setSelectedAreaLibraryIds = _c[1];
    var _d = (0, react_3.useState)(""), error = _d[0], setError = _d[1];
    var _e = (0, react_3.useState)(false), isSubmitting = _e[0], setIsSubmitting = _e[1];
    // Set once the SOP library itself has been created, so a retry only re-attempts the failed links.
    var _f = (0, react_3.useState)(null), createdSopLibraryId = _f[0], setCreatedSopLibraryId = _f[1];
    var _g = (0, react_3.useState)([]), failedAreaLibraryIds = _g[0], setFailedAreaLibraryIds = _g[1];
    var areaLibraryData = (0, area_library_1.useGetAreaLibrariesQuery)({ clientId: clientId }, { skip: !isOpen || !clientId }).data;
    var areaLibraries = (_a = areaLibraryData === null || areaLibraryData === void 0 ? void 0 : areaLibraryData.content) !== null && _a !== void 0 ? _a : [];
    var createSopLibrary = (0, sop_library_1.useCreateSopLibraryMutation)()[0];
    var linkAreaLibrary = (0, sop_library_1.useLinkAreaLibraryMutation)()[0];
    var requestTokenRef = (0, react_3.useRef)(0);
    // A synchronous lock also catches a second click before React renders the mutation's loading state.
    var requestInFlightRef = (0, react_3.useRef)(false);
    (0, react_3.useEffect)(function () { return function () {
        requestTokenRef.current += 1;
    }; }, []);
    (0, react_3.useEffect)(function () {
        if (isOpen)
            return;
        setName("");
        setSelectedAreaLibraryIds([]);
        setError("");
        setCreatedSopLibraryId(null);
        setFailedAreaLibraryIds([]);
    }, [isOpen]);
    var toggleAreaLibrary = function (areaLibraryId) {
        setSelectedAreaLibraryIds(function (current) { return (current.includes(areaLibraryId) ? current.filter(function (id) { return id !== areaLibraryId; }) : __spreadArray(__spreadArray([], current, true), [areaLibraryId], false)); });
    };
    var handleClose = function () {
        if (requestInFlightRef.current || isSubmitting) {
            return;
        }
        requestTokenRef.current += 1;
        onClose();
    };
    // Links the given area libraries and reports back which ones failed, instead of aborting on the first rejection.
    var linkAreaLibraries = function (sopLibraryId, areaLibraryIds) { return __awaiter(_this, void 0, void 0, function () {
        var results;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Promise.allSettled(areaLibraryIds.map(function (areaLibraryId) { return linkAreaLibrary({ id: sopLibraryId, areaLibraryId: areaLibraryId }).unwrap(); }))];
                case 1:
                    results = _a.sent();
                    return [2 /*return*/, areaLibraryIds.filter(function (_, index) { return results[index].status === "rejected"; })];
            }
        });
    }); };
    var handleCreate = function () { return __awaiter(_this, void 0, void 0, function () {
        var requestToken, stillFailedIds, _a, trimmedName, response, sopLibraryId, stillFailedIds, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (requestInFlightRef.current || isSubmitting) {
                        return [2 /*return*/];
                    }
                    setError("");
                    requestToken = requestTokenRef.current;
                    if (!createdSopLibraryId) return [3 /*break*/, 6];
                    if (failedAreaLibraryIds.length === 0) {
                        return [2 /*return*/];
                    }
                    requestInFlightRef.current = true;
                    setIsSubmitting(true);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, linkAreaLibraries(createdSopLibraryId, failedAreaLibraryIds)];
                case 2:
                    stillFailedIds = _c.sent();
                    if (requestToken !== requestTokenRef.current) {
                        return [2 /*return*/];
                    }
                    setFailedAreaLibraryIds(stillFailedIds);
                    if (stillFailedIds.length > 0) {
                        setError("Some area libraries still could not be linked. You can retry, or close and link them from the edit screen.");
                        onCreated === null || onCreated === void 0 ? void 0 : onCreated();
                        return [2 /*return*/];
                    }
                    onCreated === null || onCreated === void 0 ? void 0 : onCreated();
                    handleClose();
                    return [3 /*break*/, 5];
                case 3:
                    _a = _c.sent();
                    if (requestToken !== requestTokenRef.current) {
                        return [2 /*return*/];
                    }
                    setError("Unable to link the remaining area libraries. Please try again.");
                    return [3 /*break*/, 5];
                case 4:
                    requestInFlightRef.current = false;
                    setIsSubmitting(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
                case 6:
                    if (!clientId) {
                        setError("Please select an active client before adding an SOP library.");
                        return [2 /*return*/];
                    }
                    trimmedName = name.trim();
                    if (!trimmedName) {
                        setError("Please enter a name.");
                        return [2 /*return*/];
                    }
                    requestInFlightRef.current = true;
                    setIsSubmitting(true);
                    _c.label = 7;
                case 7:
                    _c.trys.push([7, 10, 11, 12]);
                    return [4 /*yield*/, createSopLibrary({ clientId: clientId, name: trimmedName }).unwrap()];
                case 8:
                    response = _c.sent();
                    if (requestToken !== requestTokenRef.current) {
                        return [2 /*return*/];
                    }
                    if (!response.success) {
                        setError(response.message || "Unable to create SOP library. Please try again.");
                        return [2 /*return*/];
                    }
                    sopLibraryId = response.content.id;
                    setCreatedSopLibraryId(sopLibraryId);
                    return [4 /*yield*/, linkAreaLibraries(sopLibraryId, selectedAreaLibraryIds)];
                case 9:
                    stillFailedIds = _c.sent();
                    if (requestToken !== requestTokenRef.current) {
                        return [2 /*return*/];
                    }
                    setFailedAreaLibraryIds(stillFailedIds);
                    if (stillFailedIds.length > 0) {
                        setError("SOP library created, but some area libraries could not be linked. You can retry, or close and link them from the edit screen.");
                        onCreated === null || onCreated === void 0 ? void 0 : onCreated();
                        return [2 /*return*/];
                    }
                    onCreated === null || onCreated === void 0 ? void 0 : onCreated();
                    handleClose();
                    return [3 /*break*/, 12];
                case 10:
                    _b = _c.sent();
                    if (requestToken !== requestTokenRef.current) {
                        return [2 /*return*/];
                    }
                    setError("Unable to create SOP library. Please try again.");
                    return [3 /*break*/, 12];
                case 11:
                    requestInFlightRef.current = false;
                    setIsSubmitting(false);
                    return [7 /*endfinally*/];
                case 12: return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsx)(react_1.Modal, { isOpen: isOpen, onOpenChange: function (open) {
            if (!open)
                handleClose();
        }, children: (0, jsx_runtime_1.jsx)(react_1.Modal.Backdrop, { isDismissable: !isSubmitting, isKeyboardDismissDisabled: isSubmitting, children: (0, jsx_runtime_1.jsx)(react_1.Modal.Container, { children: (0, jsx_runtime_1.jsxs)(react_1.Modal.Dialog, { className: "sm:max-w-[480px]", children: [(0, jsx_runtime_1.jsx)(react_1.Modal.CloseTrigger, { isDisabled: isSubmitting, onPress: handleClose }), (0, jsx_runtime_1.jsx)(react_1.Modal.Header, { children: (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "large", color: "dark-gray-1", weight: "bold", label: "Add SOP Library" }) }), (0, jsx_runtime_1.jsxs)(react_1.Modal.Body, { className: "p-1 flex flex-col gap-4", children: [(0, jsx_runtime_1.jsx)(labeled_field_1.LabeledField, { label: "SOP Library Name", children: (0, jsx_runtime_1.jsx)(react_1.TextField, { "aria-label": "SOP Library Name", value: name, onChange: setName, isRequired: true, isDisabled: createdSopLibraryId != null, children: (0, jsx_runtime_1.jsx)(react_1.Input, { placeholder: "SOP library name", className: "rounded-md" }) }) }), (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-2", children: [(0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "small", color: "medium-gray", weight: "medium", label: "Linked Area Libraries" }), areaLibraries.length === 0 && (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "small", color: "medium-gray", label: "No area libraries exist yet." }), (0, jsx_runtime_1.jsx)("div", { className: "flex flex-col gap-1 max-h-48 overflow-y-auto", children: areaLibraries.map(function (areaLibrary) {
                                                var didLinkFail = failedAreaLibraryIds.includes(areaLibrary.id);
                                                return ((0, jsx_runtime_1.jsxs)(react_1.Checkbox, { isSelected: selectedAreaLibraryIds.includes(areaLibrary.id), onChange: function () { return toggleAreaLibrary(areaLibrary.id); }, isDisabled: createdSopLibraryId != null, className: "flex items-center gap-2", children: [(0, jsx_runtime_1.jsx)(react_1.Checkbox.Control, { children: (0, jsx_runtime_1.jsx)(react_1.Checkbox.Indicator, { children: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:check-read-linear", fontSize: 12 }) }) }), (0, jsx_runtime_1.jsxs)(react_1.Checkbox.Content, { children: [areaLibrary.name, didLinkFail && " — failed to link"] })] }, areaLibrary.id));
                                            }) })] }), error && ((0, jsx_runtime_1.jsx)("div", { role: "alert", children: (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "small", color: "red-600", label: error }) }))] }), (0, jsx_runtime_1.jsxs)(react_1.Modal.Footer, { children: [(0, jsx_runtime_1.jsx)(button_component_1.ButtonComponent, { label: createdSopLibraryId ? "Close" : "Cancel", onPress: handleClose, isDisabled: isSubmitting, variant: "secondary" }), (0, jsx_runtime_1.jsx)(button_component_1.ButtonComponent, { label: createdSopLibraryId ? "Retry Linking" : "Add SOP Library", onPress: handleCreate, isPending: isSubmitting, isDisabled: createdSopLibraryId ? failedAreaLibraryIds.length === 0 : !clientId || !name.trim(), color: "white", backgroundColor: "primary-navy", hoverColor: "primary-navy-light" })] })] }) }) }) }));
}
